<template>
    <tr class="session__summary_table_item">
        <td class="session__summary_table_item_checkbox">
            <list-table-check
                :name="`summary-${index}`"
                :emit-list-name="'summary-item-list-action'"
                :index="item.learnerId"
            />
        </td>
        <td class="session__summary_table_item_name">
            {{ item.firstName }} {{ item.lastName }}
            <template v-if="isPrint">
                <br>{{ item.email }}
            </template>
        </td>
        <template v-if="!isPrint">
            <td class="session__summary_table_item_email"><a :href="`mailto:${item.email}`">{{ item.email }}</a></td>
        </template>
        <template v-if="!isPrint">
            <td class="session__summary_table_item_attendancesummary">
                <div class="session__summary_table_item_attendancesummary_label">
                    <div class="columns is-vcentered">
                        <div class="column">
                            <div class="session__summary_table_item_attendancesummary_label_text">
                                {{ attendances }}
                            </div>
                        </div>
                        <div class="column is-narrow" v-if="false">
                            <div class="session__summary_table_item_attendancesummary_label_actions">
                                <button
                                    type="button"
                                    class="btn btn--text btn--primary"
                                    id="session-summary-table-item-attendancesummary-label-action-details"
                                    @click="openDetails"
                                >{{ detailsOpen ? this.$t('ebs.sessions.summary.buttons.close') : this.$t('ebs.sessions.summary.buttons.details') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="detailsOpen && false" class="session__summary_table_item_attendancesummary_list">
                    <ul>
                        <li v-for="(item, index) in 3" :key="index">
                            <div class="columns">
                                <div class="column is-narrow">
                                    <div class="session__summary_table_item_attendancesummary_list_title">{{ $t('ebs.sessions.summary.text.date') }} {{ item
                                        }}
                                    </div>
                                </div>
                                <div class="column has-text-right">
                                    <div class="session__summary_table_item_attendancesummary_list_details">{{ $t('ebs.sessions.summary.text.absent') }}
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </td>
        </template>
        <td class="session__summary_table_item_completion">
            <template v-if="isPrint">
                <template v-if="completion === true">{{ $t('ebs.sessions.summary.labels.passed') }}</template>
                <template v-else><s>{{ $t('ebs.sessions.summary.labels.passed') }}</s></template>
                <span> / </span>
                <template v-if="completion === false">{{ $t('ebs.sessions.summary.labels.notPassed') }}</template>
                <template v-else><s>{{ $t('ebs.sessions.summary.labels.notPassed') }}</s></template>
            </template>
            <template v-else>
                <form-radio-horizontal
                    :label="''"
                    :name="`summary-completion-${index}`"
                    :items="[
                    {
                        name: this.$t('ebs.sessions.summary.labels.passed'),
                        value: true
                    },
                    {
                        name: this.$t('ebs.sessions.summary.labels.notPassed'),
                        value: false
                    }
                ]"
                    :size="'small'"
                    :disabled="disabled || isCommited"
                    v-model="completion"
                />
            </template>
        </td>
        <td class="session__summary_table_item_notes">
            <template v-if="isPrint">
                {{ notes }}
            </template>
            <template v-else>
                <form-textarea
                    :label="''"
                    :name="`summary-notes-${index}`"
                    :data-vv-as="'notes'"
                    :v-validate="'max:80'"
                    :disabled="disabled || isCommited || completion === null"
                    v-model="notes"
                    :class="notes ? (notes.length > 23 ? 'form__textarea--custom-class' : '') : ''"
                />
            </template>
        </td>
    </tr>
</template>

<script>
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import FormTextarea from '@/components/default/forms/FormTextarea'
import ListTableCheck from '@/components/default/shared/ListTableCheck'

export default {
  components: {
    ListTableCheck,
    FormTextarea,
    FormRadioHorizontal
  },
  name: 'session-summary-table-item',
  data () {
    return {
      completionValue: '',
      detailsOpen: false
    }
  },
  props: {
    index: {
      type: [String, Number],
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attendances: function () {
      if (!this.item.attendances) {
        return
      }
      const attendancesArr = this.item.attendances
      let dates = 0
      let present = 0
      for (let i = 0; i < attendancesArr.length; i++) {
        if (attendancesArr[i].attendance) {
          present++
        }
        dates++
      }
      return `${this.$t('ebs.sessions.summary.return.presentFor')} ${present}/${dates} ${dates !== 1 ? this.$t('ebs.sessions.summary.return.dates') : this.$t('ebs.sessions.summary.return.date')}`
    },
    completion: {
      get () {
        return this.item.completion
      },
      set (value) {
        this.$store.dispatch('setSummaryCompletion', { index: this.item.learnerId, value: value })
      }
    },
    notes: {
      get () {
        return this.item.notes
      },
      set (value) {
        this.$store.dispatch('setSummaryNotes', { index: this.item.learnerId, value: value })
      }
    },
    isCommited () {
      return this.item.isCommited === 'true' || this.item.isCommited === true
    },
    isPrint: function () {
      return this.$route.name === 'ebs-session-summary-print'
    }
  },
  methods: {
    openDetails: function () {
      this.detailsOpen = !this.detailsOpen
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionsummarytableitem";
</style>
